import { TABLE_API } from "../../api/table";
import Vue from "vue";

const table = {
    namespaced: true,
    state: {
        tables: [],
        totalTable: 0,
        // Her tablo için açık sekmeler - tableId: [{ recordId, title, data }]
        activeTabs: {},
        syncInProgress: false,
    },
    getters: {
        // Belirli bir tablonun açık sekmelerini döndür
        getActiveTabsByTableId: (state) => (tableId) => {
            return state.activeTabs[tableId] || [];
        },
        // Tablonun açık sekme sayısı
        getActiveTabsCount: (state) => (tableId) => {
            return (state.activeTabs[tableId] || []).length;
        },
    },
    mutations: {
        SET_TABLES: (state, payload) => {
            state.tables = payload;
        },
        SET_TOTAL_TABLE: (state, payload) => {
            state.totalTable = payload;
        },
        // Yeni sekme ekle
        ADD_ACTIVE_TAB: (state, { tableId, tab }) => {
            if (!state.activeTabs[tableId]) {
                Vue.set(state.activeTabs, tableId, []);
            }
            // Aynı kayıt zaten açıksa ekleme
            const existingTab = state.activeTabs[tableId].find(t => t.recordId === tab.recordId);
            if (!existingTab) {
                state.activeTabs[tableId].push(tab);
                // Reaktivite için force trigger
                Vue.set(state.activeTabs, tableId, [...state.activeTabs[tableId]]);
            }
        },
        // Sekme kaldır
        REMOVE_ACTIVE_TAB: (state, { tableId, recordId }) => {
            if (state.activeTabs[tableId]) {
                const newTabs = state.activeTabs[tableId].filter(tab => tab.recordId !== recordId);
                if (newTabs.length === 0) {
                    Vue.delete(state.activeTabs, tableId);
                } else {
                    Vue.set(state.activeTabs, tableId, newTabs);
                }
            }
        },
        // Tüm sekmeleri temizle (belirli tablo için)
        CLEAR_ACTIVE_TABS: (state, tableId) => {
            Vue.delete(state.activeTabs, tableId);
        },
        // Tüm sekmeleri temizle (tüm tablolar için)
        CLEAR_ALL_ACTIVE_TABS: (state) => {
            state.activeTabs = {};
        },
    },
    actions: {
        async syncTables({ commit, state }, delay = 1000) {
            
            // Eğer zaten bir sync işlemi devam ediyorsa, yenisini başlatma
            if (state.syncInProgress) {
                return;
            }
            
            state.syncInProgress = true;
            
            setTimeout(async () => {
                try {
                    const { total, tables } = await TABLE_API.listTables({
                        offset: 0,
                        limit: 1000,
                    });
                    
                    // UI'da sadece aktif tabloları göster
                    commit("SET_TABLES", tables);
                    
                    // Limit kontrolü için toplam sayı (çöp kutusu dahil)
                    commit("SET_TOTAL_TABLE", total);
                } catch (error) {
                    console.error("Error syncing tables:", error);
                } finally {
                    state.syncInProgress = false;
                }
            }, delay);
        },

        async fetchCustomerTables({ commit }, queries) {
            const { total, tables } = await TABLE_API.listTables();
            
            // UI'da sadece aktif tabloları göster (çöp kutusu ve kalıcı silinen hariç)
            commit("SET_TABLES", tables);
            
            // Limit kontrolü için backend'den dönen totalCount
            // Çöp kutusundakiler DAHİL (isTrash: true), Kalıcı silinmişler HARİÇ (isDeleted: true)
            commit("SET_TOTAL_TABLE", total);
            
            return { total, tables };
        },
        async deleteCustomerTable({ state, commit }, tableId) {
            await TABLE_API.deleteTable(tableId);
            commit(
                "SET_TABLES",
                state.tables.filter((table) => table._id !== tableId)
            );
            commit("SET_TOTAL_TABLE", state.totalTable - 1);
        },
        // Sekme actions
        addActiveTab({ commit }, { tableId, recordId, title, data }) {
            const tab = {
                recordId,
                title,
                data,
                openedAt: new Date().getTime(),
            };
            commit("ADD_ACTIVE_TAB", { tableId, tab });
        },
        removeActiveTab({ commit }, { tableId, recordId }) {
            commit("REMOVE_ACTIVE_TAB", { tableId, recordId });
        },
        closeOtherTabs({ commit, state }, { tableId, keepRecordId }) {
            if (state.activeTabs[tableId]) {
                const tabsToKeep = state.activeTabs[tableId].filter(tab => tab.recordId === keepRecordId);
                Vue.set(state.activeTabs, tableId, tabsToKeep);
            }
        },
        closeTabsToRight({ commit, state }, { tableId, fromRecordId }) {
            if (state.activeTabs[tableId]) {
                const tabs = state.activeTabs[tableId];
                const fromIndex = tabs.findIndex(tab => tab.recordId === fromRecordId);
                if (fromIndex !== -1) {
                    const tabsToKeep = tabs.slice(0, fromIndex + 1);
                    Vue.set(state.activeTabs, tableId, tabsToKeep);
                }
            }
        },
        closeTabsToLeft({ commit, state }, { tableId, fromRecordId }) {
            if (state.activeTabs[tableId]) {
                const tabs = state.activeTabs[tableId];
                const fromIndex = tabs.findIndex(tab => tab.recordId === fromRecordId);
                if (fromIndex !== -1) {
                    const tabsToKeep = tabs.slice(fromIndex);
                    Vue.set(state.activeTabs, tableId, tabsToKeep);
                }
            }
        },
        clearActiveTabsForTable({ commit }, tableId) {
            commit("CLEAR_ACTIVE_TABS", tableId);
        },
        clearAllActiveTabs({ commit }) {
            commit("CLEAR_ALL_ACTIVE_TABS");
        },
    },
};

export default table;
